module.exports = __webpack_public_path__ + "img/img-main-bg06M.26f41225.png";